<template>
<div>
	<h1>{{$t('history.history')}}</h1>
	<v-container grid-list-lg>
		<v-layout>
			<v-flex md4>
				<Datepicker v-model="date.start"
					:label="$t('workers.date_start')"
				/>
			</v-flex>
			<v-flex md4>
				<Datepicker v-model="date.end"
					:label="$t('workers.date_end')"
				/>
			</v-flex>
			<v-flex>
				<v-btn
					color="indigo"
					dark
					@click="getByDate"
				>
					Get
				</v-btn>
			</v-flex>
		</v-layout>
	</v-container>
	<v-container v-if="history.length > 0">
		<History :historys="history" />
	</v-container>
	<v-container v-else>
		<v-layout>
			<v-flex>
				{{$t('common.history_dates')}}
			</v-flex>
		</v-layout>
	</v-container>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import History from '../components/history/History'
import Datepicker from '../components/DatePicker'
import { getDates } from '../utils/helpers'

export default {
	data: vm => {
		const { start, end } = getDates()
		return {
			date: {
				start,
				end
			}
		}
	},
	components: {
		History,
		Datepicker
	},
	methods: {
		...mapActions({
			getHistory: 'history/fetch'
		}),
		getByDate() {
			this.getHistory(this.date)
		}
	},
	computed: {
		...mapState({
			history: ({ history }) => history.list
		})
	},
	created() {
		this.getByDate()
	}
}
</script>

<style scoped>
h2,
h3 {
	text-align: center;
}
.colored {
	background: rgba(216, 198, 202, 0.45);
}
</style>
